export default {
    paypal: "paypal",
    telr: "telr",
    waafi: "waafi"
};
